import type { StringItem } from '../App'
import type { StringPublic } from '../api/strings'
import { formatStringTimestamp } from './format'

export function stringPublicToItem(s: StringPublic): StringItem {
  const { time, date } = formatStringTimestamp(s.createdAt)
  return {
    id: s.stringId,
    content: s.content,
    author: `@${s.authorUsername}`,
    authorUsername: s.authorUsername,
    authorProfileImageUrl: s.authorProfileImageUrl,
    time,
    date,
  }
}
